import {
  createMessageSending,
  createOrUpdateMessageSuccess,
  createOrUpdateMessageFailure,
} from 'app/modules/messages/actions/createMessage';

import { sessionCreateSuccess, sessionUpdateSuccess, sessionFetchSuccess } from 'app/modules/session';

import { checkRules } from 'app/modules/configuration';

export default class MessageGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  handleError(err) {
    console.log('gateway encountered an error');
    console.log(err);
  }

  handleFetchSuccess(records) {
    records.forEach(record => {
      this.context.executeAction(createOrUpdateMessageSuccess(record));
    });
  }

  handleFetchError(ev) {
    console.log('fetch error');
  }

  handleRequestNewSession() {
    this.context.executeAction(checkRules());
  }

  handleRequestSessionSuccess(record) {
    this.context.executeAction(sessionFetchSuccess(record));
  }

  handleRequestSessionError() {
    this.context.executeAction(checkRules());
  }

  handleSendMessage(record) {
    this.context.executeAction(createMessageSending(record));
  }

  handleSendMessageSuccess(record) {
    this.context.executeAction(createOrUpdateMessageSuccess(record));
  }

  handleSendMessageError(id, errors) {
    this.context.executeAction(createOrUpdateMessageFailure(id, errors));
  }

  handleMessageReceived(record) {
    this.context.executeAction(createOrUpdateMessageSuccess(record));
  }

  handleEntity(record) {
    this.context.executeAction(createOrUpdateMessageSuccess(record));
  }

  handleSessionCreated(sessionObj) {
    this.context.executeAction(sessionCreateSuccess(sessionObj));
  }

  handleSessionUpdated(sessionObj) {
    this.context.executeAction(sessionUpdateSuccess(sessionObj));
  }
}
